import UserLocations from "./UserLocations";

export default UserLocations;
